import { Button, Dialog, DialogContent, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import * as apiservice from '../../../../api'
import colors from "../../../../config/colors";
import CustomTable from "../../common/customTable";
import { convertDateFormatWithTime } from "../../../utils/helpers";

const DialogComentarios = ({ open, handlerCloseModal, data }) => {

    const [commentarios,setCommentarios] = useState([])

    useEffect(() => {

        if (data) {
            apiservice.utility.getBitacoraEstadosSolicitud(0,data.numeroCaso)
            .then(response => {
                setCommentarios(response.data.result)
            })
            .catch(console.log)
        }

    },[data])

      const columnas = [
    {
      id: "estadoAnterior",
      label: "Estado Anterior",
      minWidth: 170,
    },
    {
      id: "estadoNuevo",
      label: "Estado Nuevo",
      minWidth: 170,
    },
    {
      id: "comentario",
      label: "Comentario",
      minWidth: 170,
    },
        {
      id: "fechaIngreso",
      label: "Fecha Ingreso",
      minWidth: 170,
      format: (value) => convertDateFormatWithTime(value)
    },
  ];


  return (
    <Dialog
      open={open}
      onClose={handlerCloseModal}
      sx={{ width: { xs: "100%", md: "100%" } }}
      maxWidth="sm"
      PaperProps={{
        style: {
          borderRadius: 15,
          padding: 10,
        },
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: 1,
          fontSize: 20,
          color: "green",
          "&:hover": {
            color: "red",
          },
        }}
      >
        <CloseIcon onClick={() => handlerCloseModal(false)} />
      </div>

        <DialogContent>
          <Grid container width={900}>
               <Typography variant='h4' fontWeight={700} fontFamily={'montserrat'} color={colors.primary} style={{marginBottom: 10}} >  
                  Comentarios del caso: {data && data.numeroCaso}
                </Typography>
                        <Grid item xs={12}>
          <CustomTable
            columns={columnas}
            rows={commentarios}
            totalDisponibles={commentarios.length}
            
          />
        </Grid>
          </Grid>
          
        </DialogContent>
    
    </Dialog>
  );
};

export default DialogComentarios;
